import axios from 'axios';
const APIURL = 'https://saleshangry.com/shapi/v1';

/**
 * Function is use for get the IP address of your system.
 */
export function getIpAddress() {
    return axios.get('https://api.ipify.org/?format=json');
}

/**
 * Function to login user to their account, by using simple authentication
 * Params:: email , password
 * Return:: API response
 */
export async function loginUser(postData) {
    return axios.post(APIURL + '/login', postData)
        .then(function (response) {
            return response.data.response;
        })
        .catch(function (error) {
            console.log(error);
        });
}

/**
 * Function to login user using their social media accounts
 * Params:: userData
 * Return:: API response
 */
export async function loginUserWithSocialAccounts(userData) {
    return axios.post(APIURL + '/signup', userData)
        .then(function (response) {
            return response.data.response;
        })
        .catch(function (error) {
            console.log(error);
        });
}

/**
 * Function to return response of request reset password functionality
 * Params:: email
 * Return:: API response
 */
export async function onRequestResetPassword(email) {
    return axios.post(APIURL + '/request-reset-password', email)
        .then(function (response) {
            return response.data.response;
        })
        .catch(function (error) {
            console.log(error);
        });
}

/**
 * Function to return response of reset password functionality
 */
export async function resetPassword(data) {
    return axios.post(APIURL + '/reset-password', data)
        .then(function (response) {
            return response.data.response;
        })
        .catch(function (error) {
            console.log(error);
        });
}

/**
 * Function to login user to their account, by using token
 */
export async function loginByToken(token) {
    return axios.get(APIURL + '/ot-token-user/' + token)
        .then(function (response) {
            return response.data.response;
        })
        .catch(function (error) {
            console.log(error);
        });
}



